import * as yup from "yup";

export const recuperarSenhaSchema =  yup.object().shape({
  email: yup.string().email("Endereço de e-mail inválido").required("O endereço de e-mail é obrigatório")
});
  